import { render, staticRenderFns } from "./CacheSection.vue?vue&type=template&id=301c9741&"
var script = {}
import style0 from "./CacheSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports